export default __webpack_public_path__ + "static/media/carousel6.1964d154.jpg";